import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import axios from 'axios';
import { API_LOCATION } from '@/api-config';
import { Auth } from 'aws-amplify';


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestDecisionView',
  props: {
    requestId: null,
    companyId: null,
    companyGroupId: null,
    refundAmountLabel: null
  },
  emits: ["back", "denied", "error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'back'): void;
  (e: 'denied'): void;
  (e: 'error', message: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  requestId: number;
  companyId: string;
  companyGroupId: number | string;
  refundAmountLabel?: string;
}





const denyReason = ref('');
const loading = ref(false);

async function confirmDeny() {
  loading.value = true;
  try {
    const session = await Auth.currentSession();
    const config = { headers: { Authorization: session.getIdToken().getJwtToken() } };
    const url = `${API_LOCATION}companies/${props.companyId}/groups/${props.companyGroupId}/booking-requests/${props.requestId}/deny`;
    await axios.post(url, { deny_reason: denyReason.value || null }, config);
    emit('denied');
  } catch (error: any) {
    const message = error?.response?.data?.error || 'The request could not be denied. Please try again.';
    emit('error', message);
  } finally {
    loading.value = false;
  }
}

return { __sfc: true,props, emit, denyReason, loading, confirmDeny }
}

})